import { LazyCollectionBusinessCard, LazyCollectionBusinessCreate, LazyCollectionSubscriptionCreateOrEdit, LazyCollectionBusinessFull, LazyCollectionCategoryCard, LazyCollectionCategoryCreate, LazyCollectionCategoryFull, LazyCollectionCharityCard, LazyCollectionCharityCreate, LazyCollectionCharityFull, LazyCollectionEventCard, LazyCollectionEventCreate, LazyCollectionEventFull, LazyCollectionNewsCard, LazyCollectionNewsCreate, LazyCollectionNewsFull, LazyCollectionOfferCard, LazyCollectionOfferCreate, LazyCollectionOfferFull, LazyCollectionPageCard, LazyCollectionPaymentDashboardCard, LazyCollectionProductCreateEdit, LazyCollectionProductInfo, LazyCollectionProductPricingCard, LazyCollectionReviewCard, LazyCollectionReviewCreate, LazyCollectionSubscriptionCreate, LazyCollectionSubscriptionFull, LazyCollectionReviewAdminEdit, LazyCollectionReviewEdit, LazyCollectionReviewGBFCard } from '#components'
import type { CollectionConfig } from '~/types'

export const PUBLIC_URL = 'https://grampianbusinessfinder.co.uk'
export const COLLECTIONS: CollectionConfig[] = [
  {
    title: 'Businesses',
    singular: 'business',
    live: true,
    collection: 'businesses',
    identifier: 'slug',
    icon: 'heroicons:building-storefront',
    email: {
      hooks: ['create', 'edit', 'delete', 'statusLive', 'statusHidden', 'statusVerified', 'documentationExpiry'],
      to: ['admin', 'user'],
      fields: [{ value: 'name', label: 'Business Name' }, { value: 'liveUntil', label: 'Date of Expiry' }, { value: 'insuredUntil', label: 'Date of Insurance' }],
    },
    pub: {
      title: 'Businesses',
      collectionRoute: 'directory',
      cardComponent: LazyCollectionBusinessCard,
      viewComponent: LazyCollectionBusinessFull,
      collection: 'businessesOverview',
      filterableRelations: ['categoriesOverview'],
      searchFields: ['name', 'brief', 'map'],
      defaultSortField: '-averageRating, -reviewCount',
      sortableFields: [{ value: 'name', label: 'Name' }, { value: 'averageRating, reviewCount', label: 'Rating' }, { value: 'created', label: 'Created' }],
      defaultFields: 'name, slug, map, collectionName, collectionId, qualifications, logo, id, averageRating, brief, categoriesFull, hoursFull, facebook, instagram,linkedin,pinterest, phone,whatsapp, linkedin,twitter, reviewCount, canMessage ',
    },
    dashboard: {
      expand: 'categories, openingHours',
      simplifiedRecordLayout: true,
      createComponent: LazyCollectionBusinessCreate,
    },
    admin: {
      titleString: (item: any): string => item.name,
      overviewString: (item: any): string => `Overview: ${item.id}`,
      expand: 'categories, openingHours, users_via_businesses',
      createComponent: LazyCollectionBusinessCreate,
      canCreate: true,
      // defaultFields: 'name, slug, map, collectionName, collectionId, logo, id, brief, categoriesFull',
      defaultSortField: 'name',
      searchFields: ['name', 'slug', 'brief', 'email', 'phone', 'categories'],
      columns: [
        { key: 'id', label: 'ID' },
        { key: 'name', label: 'Name', initial: true, sortable: true },
        { key: 'liveUntil', label: 'Live Until', initial: true, sortable: true },
        { key: 'insuredUntil', label: 'Insured Until', initial: true, sortable: true },
        { key: 'verified', label: 'Verified Business', initial: true, sortable: true },
        { key: 'email', label: 'Email' },
        { key: 'brief', label: 'Brief' },
        { key: 'categories', label: 'Categories' },
        { key: 'created', label: 'Created' },
        { key: 'description', label: 'Description' },
        { key: 'facebook', label: 'Facebook' },
        { key: 'gallery', label: 'Gallery' },
        { key: 'instagram', label: 'Instagram' },
        { key: 'linkedin', label: 'Linkedin' },
        { key: 'hidden', label: 'Visible / Hidden', initial: true, sortable: true },
        { key: 'openingHours', label: 'Opening Hours' },
        { key: 'owner', label: 'Owner', initial: true },
        { key: 'phone', label: 'Phone' },
        { key: 'reviews', label: 'Reviews' },
        { key: 'slug', label: 'Slug' },
        { key: 'tiktok', label: 'Tiktok' },
        { key: 'twitter', label: 'Twitter' },
        { key: 'updated', label: 'Updated' },
        { key: 'website', label: 'Website' },
      ],
    },
    filter: '',
  },
  {
    title: 'Categories',
    singular: 'category',
    live: true,
    collection: 'categories',
    identifier: 'slug',
    icon: 'heroicons:rectangle-group',
    email: {
      hooks: ['create', 'edit', 'delete'],
      to: ['admin', 'user'],
      fields: [{ value: 'name', label: 'Category Name' }, { value: 'description', label: 'Category Description' }],
    },
    pub: {
      collection: 'categoriesOverview',
      collectionRoute: 'categories',
      cardComponent: LazyCollectionCategoryCard,
      viewComponent: LazyCollectionCategoryFull,
      filterableRelations: [],
      searchFields: ['name', 'slug', 'description'],
      defaultSortField: 'name',
      sortableFields: [{ value: 'name', label: 'Name' }, { value: 'created', label: 'Created' }],
      expand: '',
      defaultFields: 'id, name, slug, description',
    },
    dashboard: {

    },
    // cardComponent:
    admin: {
      titleString: (item: any): string => item.name,
      overviewString: (item: any): string => `Overview: <a href="test">${item.id}</a>`,
      createComponent: LazyCollectionCategoryCreate,
      canCreate: true,
      searchFields: ['name', 'slug', 'description'],
      columns: [
        { key: 'id', label: 'ID' },
        { key: 'name', label: 'Name', initial: true, sortable: true },
        { key: 'description', label: 'Description', initial: true },
        { key: 'createdBy', label: 'Created', initial: true },
        { key: 'verified', label: 'Admin Verified', initial: true, sortable: true },
        { key: 'slug', label: 'Slug', initial: true },
        { key: 'updated', label: 'Updated' },
      ],
    },
  },
  {
    title: 'Plans',
    singular: 'subscription',
    label: 'Plan',
    live: true,
    collection: 'subscriptions',
    icon: 'heroicons:swatch',
    identifier: 'id',
    email: {
      to: ['admin', 'user'],
      hooks: ['create', 'renewal', 'canceled', 'past_due', 'unpaid', 'incomplete', 'incomplete_expired'],
      fields: [{ value: 'business.name', label: 'Business Name' }, { value: 'currentPeriodStart', label: 'Date of Subscription Start' }, { value: 'currentPeriodEnd', label: 'Date of Subscription Renewal' }],

    },
    admin: {
      titleString: (item: any): string => item.id,
      overviewString: (item: any): string => `Business: <a href="/admin/businesses/view?id=${item.expand.business.id}">${item.expand.business.name}</a>`,
      nonEditable: true,
      expand: 'business, user,payments_via_subscription, business, product',

      columns: [
        { key: 'id', label: 'ID' },
        { key: 'status', label: 'Status', initial: true, sortable: true },
        { key: 'currentPeriodStart', label: 'Starts', initial: true },
        { key: 'currentPeriodEnd', label: 'Ends', initial: true, sortable: true },
        { key: 'business', label: 'Business', initial: true },
        { key: 'user', label: 'User', initial: true },
      ],
    },
    dashboard: {
      viewComponent: LazyCollectionSubscriptionFull,
      createComponent: LazyCollectionSubscriptionCreateOrEdit,
      layoutProps: { maxw: true },
      expand: `payments_via_subscription, business, product`,
      fields: '*, expand.business.slug, expand.business.name, expand.business.id, expand.payments_via_subscription, expand.product',
    },
  },
  {
    title: 'Payments',
    singular: 'Payment',
    live: true,
    collection: 'payments',
    icon: 'heroicons:shopping-bag',
    identifier: 'id',
    email: {
      hooks: ['create', 'edit'],
      to: ['admin', 'user'],
      fields: [{ value: 'business.name', label: 'Business Name' }, { value: 'invoiceId', label: 'Stripe Payment Id' }, { value: 'status', label: 'Payment Status' }, { value: 'total', label: 'Payment Total' }, { value: 'subscription.subscriptionStart', label: 'Subscription Start Date' }],
    },
    admin: {
      titleString: (item: any): string => item.id,
      overviewString: (item: any): string => `Overview: ${item.id}`,
      expand: 'business, user',
      nonEditable: true,

      columns: [
        { key: 'id', label: 'ID' },
        { key: 'invoiceId', label: 'Stripe Payment Id' },
        { key: 'status', label: 'Status', initial: true, sortable: true },
        { key: 'lines', label: 'Invoice Items', initial: true },
        { key: 'total', label: 'Total', initial: true, sortable: true },
        { key: 'business', label: 'Business', initial: true },
        { key: 'user', label: 'User', initial: true },
        { key: 'product', label: 'Product', initial: true },
        { key: 'subscriptionStart', label: 'Subscription Start' },
      ],
    },
    dashboard: {
      viewComponent: LazyCollectionPaymentDashboardCard,
    },
  },
  {
    title: 'Offers',
    singular: 'offer',
    collection: 'offers',
    identifier: 'slug',
    live: true,
    icon: 'heroicons:tag',
    email: {
      hooks: ['create', 'edit', 'delete', 'expired'],
      to: ['admin', 'user'],
      fields: [{ value: 'name', label: 'Offer Name' }, { value: 'dateStart', label: 'Date of Start' }, { value: 'dateEnd', label: 'Date of End' }],
    },
    pub: {
      collectionRoute: 'offers',
      collection: 'offersOverview',
      cardComponent: LazyCollectionOfferCard,
      viewComponent: LazyCollectionOfferFull,
      filterableRelations: [],
      searchFields: ['name', 'slug', 'description'],
      defaultSortField: 'created',
      sortableFields: [{ value: 'name', label: 'Name' }, { value: 'dateEnd', label: 'End Date' }, { value: 'dateStart', label: 'Start Date' }, { value: 'created', label: 'Created' }],
      expand: 'business',
      defaultFields: 'id, name, slug, image, description, dateStart, dateEnd, collectionName, collectionId, map,businessName, businessId, businessSlug',
    },
    dashboard: {
      createComponent: LazyCollectionOfferCreate,
    },
    admin: {
      titleString: (item: any): string => item.name,
      overviewString: (item: any): string => `Overview: ${item.id}`,
      createComponent: LazyCollectionOfferCreate,
      canCreate: true,
      expand: 'business',
      searchFields: ['name', 'slug', 'business'],
      columns: [
        { key: 'id', label: 'ID' },
        { key: 'name', label: 'Name', initial: true, sortable: true },
        { key: 'slug', label: 'Slug', initial: true },
        { key: 'business', label: 'Business', initial: true },
        { key: 'dateEnd', label: 'End Date', initial: true, sortable: true },
        { key: 'dateStart', label: 'Start Date', initial: true, sortable: true },
      ],
    },
  },
  {
    title: 'Events',
    collection: 'events',
    singular: 'event',
    icon: 'heroicons:calendar',
    live: true,
    identifier: 'slug',
    email: {
      hooks: ['create', 'edit', 'delete', 'expired'],
      to: ['admin', 'user'],
      fields: [{ value: 'name', label: 'Event Name' }, { value: 'dateStart', label: 'Date of Start' }, { value: 'dateEnd', label: 'Date of End' }],
    },
    pub: {
      collectionRoute: 'events',
      collection: 'eventsOverview',
      cardComponent: LazyCollectionEventCard,
      viewComponent: LazyCollectionEventFull,
      filterableRelations: [],
      searchFields: ['name', 'slug', 'description'],
      defaultSortField: 'dateStart',
      sortableFields: [{ value: 'name', label: 'Name' }, { value: 'dateEnd', label: 'End Date' }, { value: 'dateStart', label: 'Start Date' }, { value: 'created', label: 'Created' }],
      expand: 'business',
      defaultFields: 'id, name, slug, description, dateStart, dateEnd, image, description, collectionName, collectionId, map, businessName, businessId, businessSlug',
    },
    dashboard: {
      createComponent: LazyCollectionEventCreate,
    },
    admin: {
      titleString: (item: any): string => item.name,
      createComponent: LazyCollectionEventCreate,
      overviewString: (item: any): string => `Overview: ${item.id}`,
      expand: 'business',
      canCreate: true,
      searchFields: ['name', 'slug', 'description'],
      columns: [
        { key: 'id', label: 'ID' },
        { key: 'name', label: 'Name', initial: true, sortable: true },
        { key: 'slug', label: 'Slug', initial: true },
        { key: 'dateStart', label: 'Start Date', initial: true },
        { key: 'dateEnd', label: 'End Date', initial: true },
        { key: 'hidden', label: 'Hidden', initial: true },
        { key: 'description', label: 'Description', initial: true },
        { key: 'image', label: 'Image', initial: true },
        { key: 'business', label: 'Business', initial: true },
      ],
    },
  },
  {
    title: 'News',
    collection: 'news',
    singular: 'article',
    icon: 'heroicons:calendar',
    live: true,
    identifier: 'slug',
    email: {
      hooks: ['create', 'edit', 'delete'],
      to: ['admin'],
      fields: [{ value: 'name', label: 'Article Name' }, { value: 'brief', label: 'Article Overview' }],
    },
    pub: {
      collectionRoute: 'grampian-news',
      cardComponent: LazyCollectionNewsCard,
      viewComponent: LazyCollectionNewsFull,
      hideMap: true,
      filterableRelations: [],
      searchFields: ['name', 'slug', 'description', 'brief'],
      defaultSortField: '-created',
      sortableFields: [{ value: 'name', label: 'Name' }, { value: 'created', label: 'Created' }],
      expand: 'user.name',
      defaultFields: 'id, name, slug, brief, description, image, collectionName, collectionId, created, updated, ',
    },
    admin: {
      titleString: (item: any): string => item.name,
      // createComponent: LazyCollectionEventCreate,
      createComponent: LazyCollectionNewsCreate,
      canCreate: true,
      overviewString: (item: any): string => `Overview: ${item.id}`,
      searchFields: ['name', 'slug', 'brief'],
      columns: [
        { key: 'id', label: 'ID' },
        { key: 'name', label: 'Title', initial: true, sortable: true },
        { key: 'slug', label: 'Slug', initial: true },
        { key: 'hidden', label: 'Hidden', initial: true },
        { key: 'brief', label: 'Brief', initial: true },
        { key: 'image', label: 'Image', initial: true },
      ],
    },
  },
  // {
  //   title: 'Notifications',
  //   singular: 'notification',
  //   live: true,
  //   collection: 'notifications',
  //   icon: 'heroicons:bell',
  //   identifier: 'id',
  //   admin: {
  //     titleString: (item: any): string => item.id,
  //     overviewString: (item: any): string => `Overview: ${item.id}`,
  //     expand: 'user, business, offer, event, enquiry, payment, subscription',
  //     nonEditable: true,
  //     columns: [
  //       { key: 'user', label: 'User', initial: true },
  //       { key: 'message', label: 'Message', initial: true },
  //       { key: 'type', label: 'Type', initial: true },
  //     ],
  //   },
  // },
  {
    title: 'Reviews',
    collection: 'reviews',
    singular: 'review',
    live: true,
    icon: 'heroicons:chat-bubble-oval-left',
    identifier: 'id',
    email: {
      hooks: ['create', 'edit', 'delete', 'response'],
      to: ['admin', 'user', 'recipient'],
      fields: [{ value: 'review', label: 'Review' }, { value: 'stars', label: 'Rating' }],
    },
    pub: {
      cardComponent: LazyCollectionReviewCard,
      viewComponent: LazyCollectionReviewCard,
      defaultFields: 'id, review, stars, businessName, businessSlug, businessLogo, reviewer, collectionName, collectionId',
      hideMap: true,
      collectionRoute: 'reviews',
    },
    dashboard: {
      createComponent: LazyCollectionReviewEdit,
      expand: 'business,event, offer, news, parent',
    },
    admin: {
      titleString: (item: any): string => item.id,
      overviewString: (item: any): string => `Overview: ${item.id}`,
      createComponent: LazyCollectionReviewAdminEdit,
      canCreate: false,
      defaultSortField: 'created',
      defaultSortDirection: 'asc',
      expand: 'business, reviewer, event, offer, news, parent, reviewingBusiness',
      searchFields: ['review', 'reviewer', 'business'],
      columns: [
        { key: 'review', label: 'Review', initial: true, sortable: true },
        { key: 'visible', label: 'Visible', initial: true, sortable: true },
        { key: 'stars', label: 'Stars', initial: true, sortable: true },
        { key: 'business', label: 'Business', initial: true, sortable: true },
        { key: 'reviewer', label: 'Reviewer', initial: true, sortable: true },
        { key: 'likeCount', label: 'Likes', initial: true, sortable: true },
      ],
    },
  },
  {
    title: 'GBF Reviews',
    collection: 'gbfReviews',
    singular: 'review',
    live: true,
    icon: 'heroicons:chat-bubble-oval-left',
    identifier: 'id',
    email: {
      hooks: ['create', 'edit', 'delete'],
      to: ['admin'],
      fields: [{ value: 'review', label: 'Review' }, { value: 'stars', label: 'Rating' }],
    },
    pub: {
      collection: 'gbfReviews',
      cardComponent: LazyCollectionReviewGBFCard,
      viewComponent: LazyCollectionReviewGBFCard,
      defaultFields: 'id, review, stars, business, reviewer, reviewerName, businessName, source, icon, collectionId',
      defaultSortField: '@random',
      hideMap: true,
    },
    admin: {
      titleString: (item: any): string => item.id,
      overviewString: (item: any): string => `Overview: ${item.id}`,
      expand: 'business, reviewer, event, offer, news, parent',
      createComponent: LazyCollectionReviewAdminEdit,
      canCreate: false,
      searchFields: ['review', 'reviewerName', 'businessName'],
      columns: [
        { key: 'review', label: 'Review', initial: true, sortable: true },
        { key: 'visible', label: 'Visible', initial: true, sortable: true },
        { key: 'stars', label: 'Stars', initial: true, sortable: true },
        { key: 'likeCount', label: 'Likes', initial: true, sortable: true },
        { key: 'hideBusiness', label: 'Hide Business', initial: true, sortable: true },
      ],
    },
  },
  {
    title: 'Charities',
    singular: 'charity',
    live: true,
    collection: 'charities',
    identifier: 'slug',
    icon: 'heroicons:gift',
    email: {
      hooks: ['create', 'edit', 'delete'],
      to: ['admin'],
    },
    pub: {
      collectionRoute: 'charities',
      cardComponent: LazyCollectionCharityCard,
      viewComponent: LazyCollectionCharityFull,
      filterableRelations: [],
      searchFields: ['name', 'slug', 'brief', 'description'],
      defaultSortField: 'name',
      sortableFields: [{ value: 'name', label: 'Name' }, { value: 'created', label: 'Created' }],
      expand: '',
      defaultFields: 'id, name, slug, brief, description',
    },
    dashboard: {

    },
    // cardComponent:
    admin: {
      titleString: (item: any): string => item.name,
      overviewString: (item: any): string => `Overview: <a href="test">${item.id}</a>`,
      createComponent: LazyCollectionCharityCreate,
      canCreate: true,
      searchFields: ['name', 'slug', 'brief'],
      columns: [
        { key: 'id', label: 'ID' },
        { key: 'name', label: 'Name', initial: true, sortable: true },
        { key: 'brief', label: 'brief', initial: true },
        { key: 'hidden', label: 'Hidden', initial: true, sortable: true },
        { key: 'slug', label: 'Slug', initial: true },
        { key: 'updated', label: 'Updated' },
      ],
    },
  },
  {
    title: 'Users',
    collection: 'users',
    singular: 'user',
    live: true,
    icon: 'heroicons:user',
    identifier: 'id',
    email: {
      hooks: ['create', 'edit', 'delete'],
      to: ['admin', 'user'],
    },
    admin: {
      titleString: (item: any): string => item.id,
      overviewString: (item: any): string => `Overview: ${item.id}.`,
      expand: 'businesses, subscriptions, payments, reviews, subscriptions.business, payments.business, reviews.business',
      nonEditable: true,
      canCreate: false,
      searchFields: ['name', 'email'],
      columns: [
        { key: 'name', label: 'Name', initial: true, sortable: true },
        { key: 'id', label: 'ID' },
        { key: 'lastLoggedIn', label: 'Last Logged In', initial: true, sortable: true },
        { key: 'verified', label: 'Blocked', initial: true },
        { key: 'email', label: 'Email', initial: true },
        { key: 'businesses', label: 'Businesses', initial: true },
        { key: 'reviews', label: 'Reviews', initial: true },
        { key: 'offers', label: 'Offers', initial: true },
        { key: 'events', label: 'Events', initial: true },
        { key: 'subscriptions', label: 'Subscriptions', initial: true },
        { key: 'payments', label: 'Payments', initial: true },
      ],
    },
  },
  {
    title: 'Pages',
    collection: 'pages',
    singular: 'page',
    live: false,
    icon: 'heroicons:document-text-solid',
    identifier: 'id',
    pub: {
      cardComponent: LazyCollectionPageCard,
      collectionRoute: '',
    },
  },
  {
    title: 'Products',
    collection: 'products',
    singular: 'product',
    live: true,
    icon: 'heroicons:squares-2x2',
    identifier: 'id',
    email: {
      hooks: ['create', 'edit', 'delete'],
      to: ['admin', 'user'],
    },
    pub: {
      defaultSortField: 'priceInPence',
      cardComponent: LazyCollectionProductPricingCard,
      viewComponent: LazyCollectionProductInfo,
    },
    admin: {
      titleString: (item: any): string => item.title,
      overviewString: (item: any): string => `Overview: ${item.title}.`,
      expand: '',
      nonEditable: true,
      canCreate: true,
      createComponent: LazyCollectionProductCreateEdit,
      defaultSortField: 'title',
      cardComponent: LazyCollectionProductPricingCard,
      viewComponent: LazyCollectionProductInfo,
      searchFields: ['title', 'subtitle', 'description', 'interval', 'priceInPence'],
      columns: [
        { key: 'title', label: 'Title', initial: true, sortable: true },
        { key: 'subtitle', label: 'Subtitle', initial: true, sortable: true },
        { key: 'active', label: 'Active', initial: true, sortable: true },
        { key: 'description', label: 'Description', initial: true },
        { key: 'interval', label: 'Interval', initial: true },
        { key: 'priceInPence', label: 'Price', initial: true },

      ],
    },
  },
]

export const ADMIN_ROUTES = [
  { label: 'Pages', collection: 'pages', icon: 'heroicons:document-text', sort: 'name', expand: '', fields: '' },
  { label: 'Components', collection: 'sections', icon: 'heroicons:square-3-stack-3d', sort: 'title', expand: 'pages_via_sections', fields: '*,expand.pages_via_sections.name, expand.pages_via_sections.slug, expand.pages_via_sections.id' },
  { label: 'Emails', collection: 'emails', icon: 'heroicons:envelope', sort: 'title', expand: '', fields: '' },
  { label: 'Navigation', collection: 'navigations', icon: 'heroicons:list-bullet', sort: 'order', expand: 'page', fields: '*,expand.page.slug' },
]

const adminCollections = ADMIN_ROUTES.map(x => x.collection)

export const ADMIN_COLLECTIONS = [...adminCollections]
export const COLLECTION_ROUTES = COLLECTIONS.filter(x => x.live).sort((a, b) => a.title.localeCompare(b.title)).map(x => ({ ...x, label: x.title }))

const collectionMap = new Map()

COLLECTIONS.forEach((collection) => {
  const keys = [
    collection.pub?.collectionRoute?.toLowerCase(),
    collection.pub?.collection?.toLowerCase(),
    collection.collection?.toLowerCase(),
    collection.singular?.toLowerCase(),
  ]

  keys.forEach((key) => {
    if (key) {
      collectionMap.set(key, collection)
    }
  })
})

export function GetCollection(collectionName?: string, data?: any) {
  if (!collectionName)
    return

  const name = collectionName.toLowerCase()
  const collection = collectionMap.get(name)

  if (!collection)
    return

  if (data) {
    collection.viewRoute = getPublicRoute(collection.collection, { id: data?.id, slug: data?.slug, name: data?.name })
  }
  if (data?.expand?.business) {
    data.expand.business.viewRoute = getPublicRoute(collection.collection, { id: data.expand.business?.id, slug: data.expand.business?.slug, name: data.expand.business?.name })
  }
  return collection
}

export const EMPTY_LIST_RESULT = {
  page: 0,
  perPage: 0,
  totalItems: 0,
  totalPages: 0,
  items: [],
}

export function getPublicRoute(collection: string, data: any, withUrl: boolean = false): string {
  let route = ''
  if (withUrl) {
    route = 'https://grampianbusinessfinder.co.uk'
  }
  if (collection?.toLowerCase() === 'pages') {
    if (data.slug === 'homepage')
      return `${route}/`
    return `${route}/${data.slug}`
  }
  const col = GetCollection(collection)
  if (!col?.pub?.collectionRoute || !col?.identifier)
    return ''
  if (!data[col.identifier]) {
    return 'error'
  }
  return `${route}/${col.pub.collectionRoute}/${data[col.identifier] || data.id}`
}

export function getItemRoute(collection: CollectionConfig | Ref<CollectionConfig>, data: any): string | false {
  const col = unref(collection)
  if (!col?.pub?.collectionRoute || !col?.identifier)
    return ''
  if (!data[col.identifier]) {
    return false
  }
  return `/${col.pub.collectionRoute}/${data[col.identifier] || data.id}`
}

export function getCollectionRoute(collection: string) {
  const col = GetCollection(collection)
  if (!col?.pub?.collectionRoute || !col?.identifier)
    return ''
  return `/${col.pub.collectionRoute}`
}
export function getEditRoute(collection: string, id: string) {
  const col = GetCollection(collection)
  if (!col || !col.pub?.createComponent)
    return
  return `/dashboard/${col.singular}/edit?id=${id}`
}
export function getViewRoute(collection: string, id: string) {
  const col = GetCollection(collection)
  if (!col || !col.pub?.viewComponent)
    return
  return `/dashboard/${col.singular}/view?id=${id}`
}

export function getAdminRoute(collection: string, id: string) {
  const col = GetCollection(collection)
  if (!col)
    return
  if (col.admin?.viewComponent || col.dashboard?.viewComponent) {
    return `/admin/${collection}/view?id=${id}`
  }
  return ''
}

export function getAdminEditRoute(collection: string, id: string) {
  if (ADMIN_COLLECTIONS.includes(collection)) {
    return `/admin/settings/${collection}/${id}`
  }
  const col = GetCollection(collection)
  if (col && col.admin?.createComponent) {
    return `/admin/${collection}/edit?id=${id}`
  }
  return ''
}

export const THEME_TYPES = ['blue', 'pink', 'light-blue']

export const COLLECTION_CLASS_MAP = {
  businesses: {
    heading: 'text-grad-pink',
    subheading: 'text-grad-pink',
    paragraph: 'text-blue',
    textOnBackground: 'text-white',
    button1: 'pink',
    button2: 'yellow',
  },

  offers: {
    heading: 'text-grad-yellow',
    subheading: 'text-grad-yellow',
    paragraph: 'text-white',
    textOnBackground: 'text-primary-800',
    button1: 'light-blue',
    button2: 'white',
  },
  events: {
    heading: 'text-grad-blue',
    subheading: 'text-yellow',
    paragraph: 'text-white',
    textOnBackground: 'text-white',
    button1: 'primary',
    button2: 'white',
  },

  pages: {
    heading: 'text-grad-blue',
    subheading: 'text-yellow',
    paragraph: 'text-white',
    textOnBackground: 'text-white',
    button1: 'primary',
    button2: 'white',
  },
}

export function getCollectionClass(collectionName: string): CollectionClass {
  if (collectionName === 'businessesOverview') { collectionName = 'businesses' }
  if (collectionName === 'eventsOverview') { collectionName = 'events' }
  if (collectionName === 'offersOverview') { collectionName = 'offers' }
  if (collectionName === 'gbfReviews') { collectionName = 'events' }
  if (collectionName in COLLECTION_CLASS_MAP) {
    return COLLECTION_CLASS_MAP[collectionName]
  }
  else {
    return { heading: '', subheading: '', paragraph: '', textOnBackground: '' }
  }
}
